var _linearGradient, _clipPath, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestplayerstatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 20,
    role: "img",
    "aria-label": "Test Player: Failed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Test Player: 404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    width: 43,
    height: 20,
    fill: "#8c8a82"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 365,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 610
  }, "Test Player"), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 610
  }, "Test Player"), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 915,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 230
  }, "404"), /*#__PURE__*/React.createElement("text", {
    x: 915,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 230
  }, "404"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestplayerstatus);
export default __webpack_public_path__ + "static/media/testplayerstatus.8dc316812143e0e265115b3e385562fe.svg";
export { ForwardRef as ReactComponent };